import reducer from './reducers';
import * as locationsActions from './actions';
import * as locationsSelectors from './selectors';

export { locationsActions, locationsSelectors };
export default reducer;